import { RequestProvider } from '@/shared/providers/request.provider';
import { ErrorProvider } from '@/shared/providers/errors.provider';
import { CALLS_API, API_VARIABLES } from '../values/calls.values';
import { RequestCall } from '../models/request-call.model';

class CallsServiceClass {

  /* GET */
  async getActiveCall(){
    try {
      let req = CALLS_API.GET_ACTIVE_CALL;
      return RequestProvider.get(req);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* POST */
  async createCall(set:RequestCall){
    try {
      let req = CALLS_API.START_CALL;
      return RequestProvider.post(req, set)
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* PUT */
  async endCall(meetingId:number){
    try {
      let req = CALLS_API.END_CALL.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return RequestProvider.put(req)
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* GET */
  async getCallById(meetingId:number){
    try {
      let req = CALLS_API.GET_CALL_BY_ID.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return RequestProvider.get(req)
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * Kickout participants
   * @param data
   */
  async asteriskCommand(data:any){
    let req = CALLS_API.COMMAND;
    return new Promise((resolve,reject) => {
      return RequestProvider.post(req, data).then(res => {
        resolve(res);
      }).catch(err => {
        if (err.data){
          reject(err.data);
        }else {
          reject(err);
        }
      });
    });
  }


  /**
   * POST. We need to know if on the class is connected a teacher
   *
   **/
  activeTeachers(requestPayload:any){
    return new Promise((resolve,reject) => {
      let req = CALLS_API.CALL_TEACHERS_ACTIVE;
      RequestProvider.post(req, requestPayload).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }
  getCallUsers(request:any){
    try {
      return RequestProvider.get(CALLS_API.GET_CALL_USERS, {
        classId: +request.classId,
        meetingId: request.meetingId
      });
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * GetCurrentCall
   * Note: Verify if the meeting is still alive (cache).
   **/
  async getCurrentCall(meetingId:number){
    try {
      let req = CALLS_API.GET_CURRENT_CALL.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return RequestProvider.get(req);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * Update the meeting information on the cache
   **/
  async updateCurrentCall(data:any){
    try {
      return RequestProvider.post(CALLS_API.UPDATE_CURRENT_CALL, data);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * Update user (mute, kickout)
   *
   **/
  async updateCacheUserCall(meetingId:number, data:any){
    try {
      let req = CALLS_API.UPDATE_USER_CURRENT_CALL.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return RequestProvider.post(req, data);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * Mute user in cache
   **/
  async muteCallCache(meetingId:number, data:any){
    try {
      let req = CALLS_API.MUTE_CALL.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return RequestProvider.post(req, data);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * Mute user in cache
   **/
  async lockCallCache(meetingId:number, data:any){
    try {
      let req = CALLS_API.LOCK_CALL.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return RequestProvider.post(req, data);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /**
   * GetLive Calls
   **/
  async getLiveCalls(meetings:any){
    try {
      let req = CALLS_API.LIVE_CALLS.replace(API_VARIABLES.MEETINGS, meetings.toString());
      return RequestProvider.get(req);
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async joinCall(meetingId:number){
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let req = CALLS_API.CALL_JOIN.replace(API_VARIABLES.MEETING_ID, meetingId.toString())
      return RequestProvider.get(req, {tz});
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

}

export const CallsService = new CallsServiceClass();
